import { InjectionToken } from '@angular/core';
import { ConfigAdapter } from '@common/util-models';

export const CONFIG_ADAPTER = new InjectionToken<ConfigAdapter>(
  'Adapters for individual config properties if they need to have some custom logic'
);
